import axios from 'axios';
import { IDeliveryZone } from '../_types';
import { request } from './http-client';

export const getActiveDeliveryZones = (params: any, shipperId?: string) =>
  request.get<{ delivery_zones: IDeliveryZone[] }>(
    '/v2/active-delivery-zones',
    {
      params,
      headers: shipperId ? { Shipper: shipperId } : undefined,
    },
  );
export const getIsActiveYandexOrder = (params: any) =>
  request.get('/v1/is-active-yandex-order', { params });

export const getTracking = (params: any) =>
  request.get(`/v1/tracking/courier-last-location`, { params });

export const yandexService = {
  getPlaces: (params: any, region = '71.392727, 42.899664', apikey: string) =>
    axios.get('https://search-maps.yandex.ru/v1/', {
      params: {
        ...params,
        type: 'biz',
        lang: 'ru_RU',
        apikey: apikey,
        results: 5,
        ll: region,
        spn: '6.5,6.5',
        rspn: 1,
      },
    }),
  getGeocode: (params: any) =>
    request.get<any>('/v1/map/geocoder', {
      params: {
        ...params,
        geocode: params.geocode,
        format: 'json',
        lang: 'ru_RU',
        sco: 'latlong',
        results: 5,
        type: 'geo,biz',
        ll: params.region,
        spn: '6.5,6.5',
        uri: params.uri,
        rspn: 1,
      },
    }),
  getSuggest: (params: any, region = '71.392727, 42.899664') =>
    request.get<any>('/v1/map/suggest', {
      params: {
        ...params,
        text: params.text,
        lang: 'ru_RU',
        results: 5,
        types: 'geo,biz',
        ll: region,
        spn: '6.5,6.5',
        attrs: 'uri',
      },
    }),
};
